"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewBadgeLayer = void 0;
var GameVars_1 = require("../../../GameVars");
var Utils_1 = require("../../../utils/Utils");
var AudioManager_1 = require("../../../AudioManager");
var BoardManager_1 = require("../BoardManager");
var GameConstants_1 = require("../../../GameConstants");
var NewBadgeLayer = /** @class */ (function (_super) {
    __extends(NewBadgeLayer, _super);
    function NewBadgeLayer(scene) {
        var _this = _super.call(this, scene) || this;
        var darkBackground = new Phaser.GameObjects.Graphics(_this.scene);
        darkBackground.fillStyle(0x321B38);
        darkBackground.fillRect(0, 0, GameVars_1.GameVars.gameWidth, GameVars_1.GameVars.gameHeight);
        darkBackground.alpha = .6;
        _this.add(darkBackground);
        var scaledItemsContainer = new Phaser.GameObjects.Container(_this.scene, GameVars_1.GameVars.gameWidth / 2, GameVars_1.GameVars.gameHeight / 2);
        scaledItemsContainer.scaleY = GameVars_1.GameVars.scaleY;
        _this.add(scaledItemsContainer);
        var frame = new Phaser.GameObjects.Image(_this.scene, 0, 0, "texture_atlas_1", "message_box");
        scaledItemsContainer.add(frame);
        var titleBackground = new Phaser.GameObjects.Image(_this.scene, 0, -190, "texture_atlas_0", "title_cookie_base");
        scaledItemsContainer.add(titleBackground);
        var title = new Phaser.GameObjects.Image(_this.scene, 0, -190, "texture_atlas_1", GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1 ? "title_cake_house" : "title_pastry_saloon");
        scaledItemsContainer.add(title);
        var newAreaText = new Phaser.GameObjects.Text(_this.scene, 0, -40, GameVars_1.GameVars.gameText[GameVars_1.GameVars.language]["RECREATE_BADGE"].replace("*", GameVars_1.GameVars.modeGameData.restartCounter), { fontFamily: "Baloo", fontSize: "40px", color: "#95573f", align: "center" });
        newAreaText.setOrigin(.5);
        newAreaText.setWordWrapWidth(400);
        scaledItemsContainer.add(newAreaText);
        var badget = new Phaser.GameObjects.Image(_this.scene, 0, 70, "texture_atlas_1", "restart_badge_" + GameVars_1.GameVars.modeGameData.restartCounter);
        badget.setScale(1.2);
        scaledItemsContainer.add(badget);
        var nextButton = new Utils_1.Button(_this.scene, 0, 200, "texture_atlas_1", "btn_ok_off", "btn_ok_on");
        nextButton.onDown(_this.onClickNext, _this);
        scaledItemsContainer.add(nextButton);
        _this.alpha = 0;
        _this.scene.tweens.add({
            targets: _this,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 350
        });
        AudioManager_1.AudioManager.playSound("new_recipe_appears");
        return _this;
    }
    NewBadgeLayer.prototype.onClickNext = function () {
        BoardManager_1.BoardManager.hideNewBadgeLayer();
        AudioManager_1.AudioManager.playSound("click_button");
    };
    return NewBadgeLayer;
}(Phaser.GameObjects.Container));
exports.NewBadgeLayer = NewBadgeLayer;
